import { IMandator } from '@/schemas/Mandator';

import { execGet } from '../utils/RequestUtils';

export async function getMandatorInformation(
  mandatorId: number,
  accessToken: string,
): Promise<IMandator> {
  const response = await execGet<IMandator>(
    `mandators/${mandatorId}`,
    accessToken,
  );
  return response;
}
